import request from '@/utils/request.js'

// 月卡类型
export function getCardTypeList(data) {
  return request.get('/api/H5/xmhdcardinfo/getxmcardtypelist', {
    params: data
  })
}

// 月卡列表
export function getCardList(data) {
  return request.get('/api/H5/xmhdcardinfo/getcardList', {
    params: data
  })
}

// 月卡详情
export function getCardDetail(data) {
  return request.get('/api/H5/xmhdcardinfo/getcarddetail', {
    params: data
  })
}
